module.exports = __webpack_public_path__ + "static/media/12_the-urban-farm-sending-meals-to-children_twitter_image.2ef9dd24.jpg";